import { Measure, Unit } from "convert-units";

export type RateUnits = RateMetricUnits | RateImperialUnits;
export type RateSystems = "metric" | "imperial";

export type RateMetricUnits = "rpm";
export type RateImperialUnits = "rpm";

const metric: Record<RateMetricUnits, Unit> = {
  rpm: {
    name: {
      singular: "",
      plural: "",
    },
    to_anchor: 1,
  },
};

const imperial: Record<RateImperialUnits, Unit> = {
  rpm: {
    name: {
      singular: "",
      plural: "",
    },
    to_anchor: 1,
  },
};

const measure: Measure<RateSystems, RateUnits> = {
  systems: {
    metric,
    imperial,
  },
  anchors: {
    metric: {
      imperial: {
        ratio: 1,
      },
    },
    imperial: {
      metric: {
        ratio: 1,
      },
    },
  },
};

export default measure;
